import React, { FC, useMemo } from 'react';
import { WelcomeBoxButton as WelcomeBoxButtonPk, redirectTo } from 'omni-package-react-core';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as FileDocumentIcon } from '../../assets/fileDocument.svg';
import useDocumentSummary from '../../hooks/useDocumentSummary';

export interface WelcomeBoxButtonProps { }

const WelcomeBoxButton: FC<WelcomeBoxButtonProps> = () => {
  const navigate = useNavigate();
  const { documentsCount, isVisible } = useDocumentSummary();
  const count = useMemo(() => documentsCount > 0 ? (documentsCount) : null, [documentsCount]);
  if (!isVisible) {
    return null;
  }

  return (
    <>
      {(count > 0 && isVisible) &&
        <WelcomeBoxButtonPk
          data-testid="Documents"
          LeftIcon={FileDocumentIcon}
          onClick={() => { redirectTo('documents', navigate); }}
          count={count}
          singular="document"
          plural="documents"
        />}
    </>
  );
};

export default WelcomeBoxButton;
